import {
  getLineItemLabel,
  getParticipantLabel,
} from "Constants/constant";
import useCareSector from "hooks/useCareSector";

/**
 * Care-sector-aware UI labels from SP Settings → Default care sector.
 * aged_care → Consumer / Service type; ndis → Participant / Support item.
 */
const useCareLabels = () => {
  const { careSector, isCareSectorPending } = useCareSector();

  return {
    careSector,
    isLoading: isCareSectorPending,
    isAgedCare: careSector === "aged_care",
    participantLabel: getParticipantLabel(careSector, false),
    participantLabelPlural: getParticipantLabel(careSector, true),
    participantNameLabel: `${getParticipantLabel(careSector, false)} Name`,
    lineItemLabel: getLineItemLabel(careSector),
  };
};

export default useCareLabels;
